<ng-container *ngIf="popupLoad">
  <app-highlight-overlay-bubbles
    #overlayBubble
    [readWritePermissions]="readWritePermissions"
    [lisitngDetail]="listingDetails"
    [bubbles]="listingComments"
    [cb_afterupdate]="onUpdateCallback.bind(this)">
    <div class="confirmation-dialog-backdrop"></div>
    <div class="confirmation-dialog-container custom-global-view">
      <div class="confirmation-dialog-header position-relative">
        <div class="w-75">
          <h2 class="confirmation-dialog-title text-truncate" id="property-address" hoverHighlightInfo>
            {{ title }}:
            {{ listingDetails?.property_address }}
          </h2>
        </div>
        <div>
          <img [src]="images?.mail_share_icon" alt="" class="cursor-pointer mr-3" tooltipPosition="top" (click)="openAddressOverlayPanel()" />
          <ng-container *ngIf="readWritePermissions?.can_approve">
            <ng-container *ngIf="publish_date; else no_date">
              <button class="_outline-btn mr-3" (click)="approval.toggle($event)">Live: {{ publish_date | date: 'dd/MM/yyyy' }}</button>
            </ng-container>
            <ng-template #no_date>
              <button class="_outline-btn mr-3" (click)="approval.toggle($event)" pTooltip="Approved Listing" tooltipPosition="top">Approve</button>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="isEditShow">
            <img [src]="common_images?.pencil_icon" class="pencil-cross cursor-pointer mr-2" width="15px" (click)="listingEdit()" />
          </ng-container>
          <img [src]="common_images?.close_icon" class="pencil-cross cursor-pointer" width="24px" (click)="close()" />
          <div class="position-relative">
            <p-overlayPanel #approval class="live-publisher" [dismissable]="true" [showCloseIcon]="true" appendTo="body">
              <div class="d-flex align-items-center">
                <div class="d-flex">
                  <p-radioButton
                    name="send"
                    value="Go live now"
                    [(ngModel)]="livePlan"
                    [ngModelOptions]="{ standalone: true }"
                    inputId="sendOption"></p-radioButton>
                  <p class="pt-2 pb-2 pl-2 pr-3" for="sendOption">Go live now</p>
                </div>
                <div class="d-flex">
                  <p-radioButton
                    name="send"
                    value="Schedule"
                    [(ngModel)]="livePlan"
                    [ngModelOptions]="{ standalone: true }"
                    inputId="sendRemainderOption"></p-radioButton>
                  <p class="pt-2 pb-2 pl-2 pr-3" for="sendRemainderOption">Request Live Date</p>
                </div>
              </div>
              <ng-container *ngIf="livePlan === 'Schedule'">
                <div class="col-sm-12 mt-3">
                  <p-calendar
                    dateFormat="dd/mm/yy"
                    placeholder="dd/mm/yy"
                    [firstDayOfWeek]="1"
                    [(ngModel)]="schedule"
                    [ngModelOptions]="{ standalone: true }">
                  </p-calendar>
                </div>
              </ng-container>
              <button class="_outline-btn mt-3" (click)="sendApproval(); approval.hide()">Save</button>
            </p-overlayPanel>
          </div>
        </div>
        <div class="email-template-box" *ngIf="show_email_template">
          <i class="pi pi-times cross-icon" (click)="show_email_template = false"></i>
          <div class="row">
            <p class="heading-style f-16">Email Send</p>
            <div>
              <div class="d-flex align-items-center justify-content-between mt-3">
                <p>Email To</p>
                <button class="email-add" (click)="addEmailTo()"><i class="pi pi-plus f-14"></i></button>
              </div>
              <div class="user-view-workarea px-0 pb-0">
                <form class="form">
                  <div class="create-user-form">
                    <ng-container *ngFor="let item of email_to; let ind = index">
                      <div class="row">
                        <div class="col-md-4 pr-0">
                          <div class="form-group mb-2">
                            <ng-select
                              [items]="selectAssign"
                              bindLabel="name"
                              bindValue="value"
                              [searchable]="false"
                              [(ngModel)]="item.type"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Please Select"
                              [multiple]="false"
                              (change)="item.email_to = null"
                              class="w-76 mb-1 trigger-Name"
                              name="all_user_receiver_type"
                              id="all_user_receiver_type">
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-md-7" *ngIf="item.type">
                          <ng-container *ngIf="item.type === 'staff'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="originalAssigns"
                                [(selectedOptions)]="item.email_to"
                                optionLabel="full_name"
                                optionValue="_id"
                                placeholder="Please Select"
                                >\
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'team'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="Teams"
                                [(selectedOptions)]="item.email_to"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'user_role'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="roles"
                                [(selectedOptions)]="item.email_to"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'contact'">
                            <div class="form-group mb-2">
                              <re-multiselect
                                [module]="'contacts'"
                                [truncate]="13"
                                [selected_ids]="item.email_to"
                                (onUpdate)="onUpdateMSelect($event, 'email_to', ind)"
                                [placeholder]="'Select Contact'"
                                [style]="{ width: '100%' }">
                              </re-multiselect>
                            </div>
                          </ng-container>
                        </div>
                        <div class="col-md-1">
                          <div class="form-group mt-2">
                            <label for=""></label>
                            <i class="pi pi-times-circle cursor-pointer" (click)="removeEmailTo(ind)"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </form>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-3">
                <p>Email CC</p>
                <button class="email-add" (click)="addEmailCC()"><i class="pi pi-plus f-14"></i></button>
              </div>
              <div class="user-view-workarea px-0 pb-0">
                <form class="form">
                  <div class="create-user-form">
                    <ng-container *ngFor="let item of email_cc; let ind = index">
                      <div class="row">
                        <div class="col-md-4 pr-0">
                          <div class="form-group mb-2">
                            <ng-select
                              [items]="selectAssign"
                              bindLabel="name"
                              bindValue="value"
                              [searchable]="false"
                              [(ngModel)]="item.type"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Please Select"
                              [multiple]="false"
                              (change)="item.email_cc = null"
                              class="w-76 mb-1 trigger-Name"
                              name="all_user_receiver_type"
                              id="all_user_receiver_type">
                            </ng-select>
                          </div>
                        </div>

                        <div class="col-md-7" *ngIf="item.type">
                          <ng-container *ngIf="item.type === 'staff'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="originalAssigns"
                                [(selectedOptions)]="item.email_cc"
                                optionLabel="full_name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'team'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="Teams"
                                [(selectedOptions)]="item.email_cc"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'user_role'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="roles"
                                [(selectedOptions)]="item.email_cc"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'contact'">
                            <div class="form-group mb-2">
                              <re-multiselect
                                [module]="'contacts'"
                                [truncate]="13"
                                [selected_ids]="item.email_cc"
                                (onUpdate)="onUpdateMSelect($event, 'email_cc', ind)"
                                [placeholder]="'Select Contact'"
                                [style]="{ width: '100%' }">
                              </re-multiselect>
                            </div>
                          </ng-container>
                        </div>

                        <div class="col-md-1">
                          <div class="form-group mt-2">
                            <label for=""></label>
                            <i class="pi pi-times-circle cursor-pointer" (click)="removeEmailCC(ind)"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </form>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-3">
                <p>Email BCC</p>
                <button class="email-add" (click)="addEmailBCC()"><i class="pi pi-plus f-14"></i></button>
              </div>
              <div class="user-view-workarea px-0 pb-0">
                <form class="form">
                  <div class="create-user-form">
                    <ng-container *ngFor="let item of email_bcc; let ind = index">
                      <div class="row">
                        <div class="col-md-4 pr-0">
                          <div class="form-group mb-2">
                            <ng-select
                              [items]="selectAssign"
                              bindLabel="name"
                              bindValue="value"
                              [searchable]="false"
                              [(ngModel)]="item.type"
                              [ngModelOptions]="{ standalone: true }"
                              placeholder="Please Select"
                              [multiple]="false"
                              (change)="item.email_bcc = null"
                              class="w-76 mb-1 trigger-Name"
                              name="all_user_receiver_type"
                              id="all_user_receiver_type">
                            </ng-select>
                          </div>
                        </div>

                        <div class="col-md-7" *ngIf="item.type">
                          <ng-container *ngIf="item.type === 'staff'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="originalAssigns"
                                [(selectedOptions)]="item.email_bcc"
                                optionLabel="full_name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'team'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="Teams"
                                [(selectedOptions)]="item.email_bcc"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'user_role'">
                            <div class="form-group mb-2">
                              <re-multiSelect
                                [options]="roles"
                                [(selectedOptions)]="item.email_bcc"
                                optionLabel="name"
                                optionValue="_id"
                                placeholder="Please Select">
                              </re-multiSelect>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.type === 'contact'">
                            <div class="form-group mb-2">
                              <re-multiselect
                                [module]="'contacts'"
                                [truncate]="13"
                                [selected_ids]="item.email_bcc"
                                (onUpdate)="onUpdateMSelect($event, 'email_bcc', ind)"
                                [placeholder]="'Select Contact'"
                                [style]="{ width: '100%' }">
                              </re-multiselect>
                            </div>
                          </ng-container>
                        </div>
                        <div class="col-md-1">
                          <div class="form-group mt-2">
                            <label for=""></label>
                            <i class="pi pi-times-circle cursor-pointer" (click)="removeEmailBCC(ind)"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </form>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p class="mb-1">Select Email Template</p>
                  <ng-select
                    [items]="emailTemplates"
                    bindLabel="name"
                    bindValue="_id"
                    [searchable]="false"
                    [(ngModel)]="email_template"
                    [ngModelOptions]="{ standalone: true }"
                    placeholder="Please Select Email Template"
                    [multiple]="false"
                    (change)="onChange($event)"
                    class="w-76 mb-1 trigger-Name"
                    name="all_user_receiver_type"
                    id="all_user_receiver_type">
                  </ng-select>
                </div>
                <div class="col-sm-12">
                  <p class="mt-2 mb-1">Subject</p>
                  <input type="text" class="site-input" [(ngModel)]="email_subject" [ngModelOptions]="{ standalone: true }" />
                  <p class="text-danger" *ngIf="!email_subject">Subject is required</p>
                </div>
                <div class="col-sm-12 _paragraph mt-2">
                  <p class="mt-2 mb-1">Message</p>
                  <ckeditor [(ngModel)]="email_message" [ngModelOptions]="{ standalone: true }" [editor]="Editor"> </ckeditor>
                  <p class="text-danger" *ngIf="!email_message">Message is required</p>
                </div>
              </div>
            </div>
            <div class="col-lg-12 mt-3 d-flex align-items-center justify-content-between">
              <h4 class="f-12 _fw-600"></h4>
              <button class="_outline-btn text-right" [class.disabled]="emailBtnDisabled" (click)="sendEmail()">Send Email</button>
            </div>
          </div>
        </div>
      </div>
      <div class="confirmation-dialog-body pt-2">
        <div class="left-panel">
          <p class="_fw-600 f-18" hoverHighlightInfo id="listing-greeting">Hi {{ listingDetails?.agent?.first_name }},</p>
          <p style="color: #48596a" class="mt-2 _fw-400" hoverHighlightInfo id="lisitng-heading-description">
            This is a preview of your listing. Provide your approval or comments below.
          </p>
          <p style="color: #48596a" class="mt-3 _fw-400">Ctrl+ to create comments on the preview.</p>
          <div>
            <div class="form-group mt-3">
              <div class="divShadow p-0 position-relative">
                <div class="position-absolute w-100">
                  <div class="d-flex justify-content-between">
                    <p class="statusStyle" *ngIf="dayAgo == '1'; else days">Added&nbsp;{{ dayAgo }}&nbsp;day ago</p>
                    <ng-template #days>
                      <p class="statusStyle" hoverHighlightInfo id="listing-image-day-ago">Added&nbsp;{{ dayAgo }}&nbsp;days ago</p>
                    </ng-template>
                    <p class="statusStyle" hoverHighlightInfo id="listing-image-day-ago">
                      {{ listingDetails?.property_status }}
                    </p>
                  </div>
                </div>
                <ng-container *ngIf="imagesPath">
                  <div hoverHighlightInfo id="listing-image-path-single" class="position-relative">
                    <img src="{{ S3Path + imagesPath }}" alt="" class="main-images" id="imageId" />
                    <p class="imgIndex" hoverHighlightInfo id="listing-image-index">Image {{ imageIndex ? imageIndex : 1 }}</p>
                  </div>
                </ng-container>
                <ng-container *ngIf="!imagesPath">
                  <ng-container *ngIf="listingDetails?.property_images?.length > 0; else elsePart">
                    <div hoverHighlightInfo id="listing-image-path-single" class="position-relative">
                      <img [src]="getImageByPath(listingDetails?.property_images[0])" alt="" class="main-images" />
                      <p class="imgIndex" hoverHighlightInfo id="listing-image-index">Image {{ imageIndex ? imageIndex : 1 }}</p>
                    </div>
                  </ng-container>
                  <ng-template #elsePart>
                    <div id="listing-image-not-found-single" class="elsePart" hoverHighlightInfo>
                      <img [src]="common_images?.image_not_found" class="no-images" />
                    </div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
            <div class="form-group">
              <div class="divShadow p-0">
                <ng-container *ngIf="listingDetails?.property_images?.length > 0; else elsePart">
                  <p-carousel
                    [responsiveOptions]="responsiveOptions"
                    [value]="displayedImages"
                    styleClass="custom-carousel"
                    [numVisible]="3"
                    [numScroll]="1"
                    [circular]="true"
                    [showNavigators]="false">
                    <ng-template pTemplate="header"> </ng-template>
                    <ng-template let-product pTemplate="item">
                      <div class="product-item">
                        <div class="product-item-content" [class.text-center]="listingDetails?.property_images?.length == 1">
                          <img
                            class="vidimg"
                            [class.carousel-one-image]="listingDetails?.property_images?.length == 1"
                            [src]="getSliderImageByPath(product)"
                            class="imageStyle cursor-pointer"
                            (click)="getImagePath(product)"
                            [ngStyle]="{ border: imagesPath == (product?.popupPath ?? product?.thumbPath) ? '3px solid #229276' : 'none' }" />
                        </div>
                      </div>
                    </ng-template>
                  </p-carousel>
                </ng-container>
                <ng-template #elsePart>
                  <div class="d-flex align-items-center justify-content-center">
                    <img [src]="common_images?.image_not_found" class="no-images-slider" />
                  </div>
                </ng-template>
                <div>
                  <button class="carousel-prev-btn" (click)="goToPrevious()"><i class="pi pi-chevron-left f-14"></i></button>
                  <button class="carousel-next-btn" (click)="goToNext()"><i class="pi pi-chevron-right f-14"></i></button>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="divShadow p-0">
                <div hoverHighlightInfo id="listing-address-bottom">
                  <p class="addressStyle" *ngIf="listingDetails?.property_address">{{ listingDetails?.property_address }}</p>
                </div>
                <div class="d-flex align-items-center">
                  <div class="w-50 mr-4">
                    <div class="pricingDetail" hoverHighlightInfo id="listing-price">
                      <div class="d-flex align-items-start-flex">
                        <img [src]="common_images?.tag_one_icon" width="18" class="mr-2" alt="" />
                        <p
                          class="mt-1"
                          *ngIf="
                            listingDetails?.hasOwnProperty('display_price') == true &&
                              listingDetails?.display_price != '' &&
                              listingDetails?.display_price != null;
                            else displyedPrice
                          ">
                          Display Price
                        </p>
                        <ng-template #displyedPrice>
                          <p class="mt-1">Price</p>
                        </ng-template>
                      </div>
                      <div>
                        <ng-container
                          *ngIf="listingDetails?.property_status == 'For Lease' || listingDetails?.property_status == 'Leased'; else forSaleProperty">
                          <p
                            *ngIf="
                              listingDetails?.hasOwnProperty('priceDisplay') == true &&
                                listingDetails?.priceDisplay != '' &&
                                listingDetails?.priceDisplay != null;
                              else rentPerWeekPrice
                            "
                            class="f-12 font-weight-bold">
                            {{ listingDetails?.priceDisplay }}
                          </p>
                          <ng-template #rentPerWeekPrice>
                            <p class="f-12 font-weight-bold">${{ listingDetails?.rentalPerWeek }}</p>
                          </ng-template>
                        </ng-container>
                        <ng-template #forSaleProperty>
                          <p
                            *ngIf="
                              listingDetails?.hasOwnProperty('display_price') == true &&
                                listingDetails?.display_price != '' &&
                                listingDetails?.display_price != null;
                              else valuePrice
                            "
                            class="f-12 font-weight-bold">
                            {{ listingDetails?.display_price }}
                          </p>
                          <ng-template #valuePrice>
                            <p class="f-12 font-weight-bold">${{ listingDetails?.value }}</p>
                          </ng-template>
                        </ng-template>
                      </div>
                    </div>
                    <div class="pricingDetail" hoverHighlightInfo id="listing-bath">
                      <div class="d-flex align-items-start-flex">
                        <img [src]="common_images?.cil_bathroom_icon" width="18" class="mr-2" alt="" />
                        <p class="mt-1">Bathroom</p>
                      </div>
                      <div>
                        <p *ngIf="listingDetails?.baths" class="f-12 font-weight-bold">{{ listingDetails.baths }}</p>
                      </div>
                    </div>
                    <div class="pricingDetail" hoverHighlightInfo id="listing-size">
                      <div class="d-flex align-items-start-flex">
                        <img [src]="common_images?.area_1_icon" width="18" class="mr-2" alt="" />
                        <p class="mt-1">Land Size</p>
                      </div>
                      <div>
                        <p *ngIf="listingDetails?.land_area" class="f-12 font-weight-bold">
                          {{ listingDetails.land_area }}
                          <span *ngIf="listingDetails?.land_area_type == 'm2'; else elsepart">m<sup>2</sup></span>
                          <ng-template #elsepart>
                            {{ listingDetails.land_area_type }}
                          </ng-template>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="pricingDetail" hoverHighlightInfo id="lisiting-bedrooms">
                      <div class="d-flex align-items-start-flex">
                        <img [src]="common_images?.single_bed_icon" width="18" class="mr-2" alt="" />
                        <p class="mt-1">Bedroom</p>
                      </div>
                      <div>
                        <p *ngIf="listingDetails?.beds" class="f-12 font-weight-bold">{{ listingDetails.beds }}</p>
                      </div>
                    </div>

                    <div class="pricingDetail" hoverHighlightInfo id="lisitng-garage">
                      <div class="d-flex align-items-start-flex">
                        <img [src]="common_images?.garage_icon" width="18" class="mr-2" alt="" />
                        <p class="mt-1">Garage</p>
                      </div>
                      <div>
                        <p *ngIf="listingDetails?.garage" class="f-12 font-weight-bold">{{ listingDetails.garage }}</p>
                      </div>
                    </div>

                    <div class="pricingDetail" hoverHighlightInfo id="lisitng-house-size">
                      <div class="d-flex align-items-start-flex">
                        <img [src]="common_images?.house_plan_icon" width="18" class="mr-2" alt="" />
                        <p class="mt-1">House Size</p>
                      </div>
                      <div>
                        <p *ngIf="listingDetails?.building_area" class="f-12 font-weight-bold">
                          {{ listingDetails.building_area }}
                          <span *ngIf="listingDetails.building_area_type == 'm2'; else elsepart">m<sup>2</sup></span>
                          <ng-template #elsepart>
                            {{ listingDetails.building_area_type }}
                          </ng-template>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="divShadow p-0">
                <div class="row">
                  <div class="pricingDetail border-bottom-0 col-sm-6 p-3" hoverHighlightInfo id="lisitng-agent-primary">
                    <div class="d-flex align-items-center" *ngIf="listingDetails?.agent?.full_name">
                      <p class="agent-title f-18" title="{{ listingDetails?.agent?.full_name }}">
                        <ng-container *ngIf="listingDetails?.agent?.photo; else elsePart">
                          <img src="{{ S3Path + listingDetails?.agent?.photo }}" alt="Secondary Agent" class="agent-title" width="18px" />
                        </ng-container>
                        <ng-template #elsePart>
                          {{ listingDetails?.agent?.first_name?.charAt(0) + '' + listingDetails?.agent?.last_name?.charAt(0) }}
                        </ng-template>
                      </p>
                      <div class="ml-2">
                        <p class="f-14 font-weight-bold">{{ listingDetails?.agent?.full_name }}</p>
                        <p class="f-12" *ngIf="listingDetails?.agent?.full_name">Agent</p>
                      </div>
                    </div>
                  </div>
                  <div class="pricingDetail border-bottom-0 col-sm-6 p-3" hoverHighlightInfo id="lisitng-agent-secondary">
                    <div class="d-flex align-items-center" *ngIf="listingDetails?.secondaryagent?.full_name">
                      <p class="agent-title f-18" title="{{ listingDetails?.secondaryagent?.full_name }}">
                        <ng-container *ngIf="listingDetails?.secondaryagent?.photo; else secElsePart">
                          <img src="{{ S3Path + listingDetails?.secondaryagent?.photo }}" alt="Secondary Agent" class="agent-title" width="18px" />
                        </ng-container>
                        <ng-template #secElsePart>
                          {{ listingDetails?.secondaryagent?.first_name?.charAt(0) + '' + listingDetails?.secondaryagent?.last_name?.charAt(0) }}
                        </ng-template>
                      </p>
                      <div class="ml-2">
                        <p class="f-14 font-weight-bold">{{ listingDetails?.secondaryagent?.full_name }}</p>
                        <p class="f-12" *ngIf="listingDetails?.secondaryagent?.full_name">Agent</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="divShadow p-0">
                <div class="priDetail pt-0" hoverHighlightInfo id="listing-inspection">
                  <p class="insp-heading f-18">Inspection</p>
                  <ng-container *ngIf="listingDetails?.appointments_and_inspections?.length > 0; else no_inspection">
                    <div *ngFor="let item of listingDetails?.appointments_and_inspections" class="mb-2">
                      <ng-container *ngIf="item?.isInspection == true">
                        <p class="font-style">{{ item.event.start.dateTime | wallClock | date: 'EEEE, d MMM y' }}</p>
                        <p class="time-style">
                          {{ getTimeFormat(item.event.start.dateTime) }} -
                          {{ getTimeFormat(item.event.end.dateTime) }}
                        </p>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #no_inspection>
                    <p class="font-style">There are no upcoming inspections for this property</p>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="divShadow p-0">
                <ng-container *ngIf="listingDetails?.listing_type === 'Auction'">
                  <div class="priDetail pt-0" hoverHighlightInfo id="listing-auction">
                    <p class="insp-heading f-18">Auction</p>
                    <p class="time-style">{{ getTimeFormat(listingDetails.startTime) }}</p>
                    <p class="font-style">{{ listingDetails?.date | date: 'EEEE, d MMM y' }}</p>
                  </div>
                </ng-container>
                <div class="priDetail border-bottom-0" hoverHighlightInfo id="lisitng-overview">
                  <p class="insp-heading f-18">Listing Overview</p>
                  <p class="font-style font-weight-bold mb-2">{{ listingDetails?.heading }}</p>
                  <p class="time-style" [innerHTML]="listingDetails?.description_garax"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-panel">
          <app-approvel-comments
            [showUserComments]="true"
            [readWritePermissions]="readWritePermissions"
            [vendorComments]="vendorComments"
            [comments]="listingComments"
            [lisitngDetail]="listingDetails"
            [cb_afterupdate]="onUpdatecallback.bind(this)"></app-approvel-comments>
        </div>
      </div>
      <div class="confirmation-dialog-footer mr-2 mb-3 ml-auto"></div>
    </div>
  </app-highlight-overlay-bubbles>
</ng-container>

<ng-container *ngIf="pageLoad == true">
  <div class="page-box">
    <div class="office-header-style" [ngStyle]="{ 'background-color': listingDetails?.offices?.background_color }">
      <ng-container *ngIf="listingDetails?.office_logos; else officeName">
        <div>
          <img src="{{ S3Path + listingDetails?.office_logos?.file }}" alt="" width="50" height="45" class="mr-2" />
        </div>
      </ng-container>
      <ng-template #officeName>
        <p class="f-24" [ngStyle]="{ color: listingDetails?.offices?.text_color }">{{ listingDetails?.offices?.name }}</p>
      </ng-template>
    </div>
    <div class="body-section">
      <div class="w-875 m-auto">
        <div class="header-sec">
          <h2 class="page-title" id="property-address">{{ title }}</h2>
        </div>
        <div class="body-sec">
          <div class="confirmation-dialog-body pt-2">
            <div class="left-panel-page">
              <p class="mt-4 _fw-600 f-18" id="listing-greeting">Hi {{ listingDetails?.agent?.first_name }},</p>
              <p style="color: #48596a" class="mt-2 _fw-400" id="lisitng-heading-description">
                This is a preview of your listing. Provide your approval or comments below.
              </p>
              <div>
                <div class="form-group mt-3">
                  <div class="divShadow p-0 position-relative">
                    <div class="position-absolute w-100">
                      <div class="d-flex justify-content-between">
                        <p class="statusStyle" *ngIf="dayAgo == '1'; else days">Added&nbsp;{{ dayAgo }}&nbsp;day ago</p>
                        <ng-template #days>
                          <p class="statusStyle" id="listing-image-day-ago">Added&nbsp;{{ dayAgo }}&nbsp;days ago</p>
                        </ng-template>
                        <p class="statusStyle" id="listing-image-day-ago">
                          {{ listingDetails?.property_status }}
                        </p>
                      </div>
                    </div>
                    <ng-container *ngIf="imagesPath">
                      <div id="listing-image-path-single" class="position-relative">
                        <img src="{{ S3Path + imagesPath }}" alt="" class="main-images-page" id="imageId" />
                        <p class="imgIndex" id="listing-image-index">Image {{ imageIndex ? imageIndex : 1 }}</p>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!imagesPath">
                      <ng-container *ngIf="listingDetails?.property_images?.length > 0; else elsePart">
                        <div id="listing-image-path-single" class="position-relative">
                          <img [src]="getImageByPath(listingDetails?.property_images[0])" alt="" class="main-images-page" />
                          <p class="imgIndex" id="listing-image-index">Image {{ imageIndex ? imageIndex : 1 }}</p>
                        </div>
                      </ng-container>
                      <ng-template #elsePart>
                        <div id="listing-image-not-found-single" class="elsePart">
                          <img [src]="common_images?.image_not_found" class="no-images" />
                        </div>
                      </ng-template>
                    </ng-container>
                  </div>
                </div>
                <div class="form-group">
                  <div class="divShadow p-0">
                    <ng-container *ngIf="listingDetails?.property_images?.length > 0; else elsePart">
                      <p-carousel
                        [responsiveOptions]="responsiveOptions"
                        [value]="listingDetails?.property_images"
                        styleClass="custom-carousel"
                        [numVisible]="4"
                        [numScroll]="1"
                        [circular]="true"
                        [showNavigators]="true">
                        <ng-template pTemplate="header"> </ng-template>
                        <ng-template let-product pTemplate="item">
                          <div class="product-item">
                            <div class="product-item-content" [class.text-center]="listingDetails?.property_images?.length == 1">
                              <img
                                class="vidimg"
                                [class.carousel-one-image]="listingDetails?.property_images?.length == 1"
                                [src]="getSliderImageByPath(product)"
                                class="imageStyle-page cursor-pointer"
                                (click)="getImagePath(product)"
                                [ngStyle]="{
                                  width:
                                    listingDetails?.property_images?.length == 3
                                      ? '265px'
                                      : listingDetails?.property_images?.length == 2
                                        ? '400px'
                                        : null,
                                }" />
                            </div>
                          </div>
                        </ng-template>
                      </p-carousel>
                    </ng-container>
                    <ng-template #elsePart>
                      <div class="d-flex align-items-center justify-content-center">
                        <img [src]="common_images?.image_not_found" class="no-images-slider" />
                      </div>
                    </ng-template>
                  </div>
                </div>
                <div class="form-group">
                  <div class="divShadow p-0">
                    <div id="listing-address-bottom">
                      <p class="addressStyle" *ngIf="listingDetails?.property_address">
                        {{ listingDetails?.property_address }}
                      </p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="w-50 mr-4">
                        <div class="pricingDetail" id="listing-price">
                          <div class="d-flex align-items-start-flex">
                            <img [src]="common_images?.tag_one_icon" width="18" class="mr-2" alt="" />
                            <p
                              class="mt-1"
                              *ngIf="
                                listingDetails?.hasOwnProperty('display_price') == true &&
                                  listingDetails?.display_price != '' &&
                                  listingDetails?.display_price != null;
                                else displayPrice
                              ">
                              Display Price
                            </p>
                            <ng-template #displayPrice>
                              <p class="mt-1">Price</p>
                            </ng-template>
                          </div>
                          <div>
                            <ng-container
                              *ngIf="
                                listingDetails?.property_status == 'For Lease' || listingDetails?.property_status == 'Leased';
                                else forSaleProperty
                              ">
                              <p
                                *ngIf="
                                  listingDetails?.hasOwnProperty('priceDisplay') == true &&
                                    listingDetails?.priceDisplay != '' &&
                                    listingDetails?.priceDisplay != null;
                                  else rentPerWeekPrice
                                "
                                class="f-12 font-weight-bold">
                                {{ listingDetails?.priceDisplay }}
                              </p>
                              <ng-template #rentPerWeekPrice>
                                <p class="f-12 font-weight-bold">{{ listingDetails?.rentalPerWeek | currency: 'symbol' : '1.0-0' }}</p>
                              </ng-template>
                            </ng-container>
                            <ng-template #forSaleProperty>
                              <p
                                *ngIf="
                                  listingDetails?.hasOwnProperty('display_price') == true &&
                                    listingDetails?.display_price != '' &&
                                    listingDetails?.display_price != null;
                                  else valuePrice
                                "
                                class="f-12 font-weight-bold">
                                {{ listingDetails?.display_price }}
                              </p>
                              <ng-template #valuePrice>
                                <p class="f-12 font-weight-bold">${{ listingDetails?.value }}</p>
                              </ng-template>
                            </ng-template>
                          </div>
                        </div>
                        <div class="pricingDetail" id="listing-bath">
                          <div class="d-flex align-items-start-flex">
                            <img [src]="common_images?.cil_bathroom_icon" width="18" class="mr-2" alt="" />
                            <p class="mt-1">Bathroom</p>
                          </div>
                          <div>
                            <p *ngIf="listingDetails?.baths" class="f-12 font-weight-bold">{{ listingDetails.baths }}</p>
                          </div>
                        </div>
                        <div class="pricingDetail" id="listing-size">
                          <div class="d-flex align-items-start-flex">
                            <img [src]="common_images?.area_1_icon" width="18" class="mr-2" alt="" />
                            <p class="mt-1">Land Size</p>
                          </div>
                          <div>
                            <p *ngIf="listingDetails?.land_area" class="f-12 font-weight-bold">
                              {{ listingDetails.land_area }}
                              <span *ngIf="listingDetails?.land_area_type == 'm2'; else elsePart">m<sup>2</sup></span>
                              <ng-template #elsePart>
                                {{ listingDetails.land_area_type }}
                              </ng-template>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="w-50">
                        <div class="pricingDetail" id="lisiting-bedrooms">
                          <div class="d-flex align-items-start-flex">
                            <img [src]="common_images?.single_bed_icon" width="18" class="mr-2" alt="" />
                            <p class="mt-1">Bedroom</p>
                          </div>
                          <div>
                            <p *ngIf="listingDetails?.beds" class="f-12 font-weight-bold">{{ listingDetails.beds }}</p>
                          </div>
                        </div>

                        <div class="pricingDetail" id="lisitng-garage">
                          <div class="d-flex align-items-start-flex">
                            <img [src]="common_images?.garage_icon" width="18" class="mr-2" alt="" />
                            <p class="mt-1">Garage</p>
                          </div>
                          <div>
                            <p *ngIf="listingDetails?.garage" class="f-12 font-weight-bold">{{ listingDetails.garage }}</p>
                          </div>
                        </div>

                        <div class="pricingDetail" id="lisitng-house-size">
                          <div class="d-flex align-items-start-flex">
                            <img [src]="common_images?.house_plan_icon" width="18" class="mr-2" alt="" />
                            <p class="mt-1">House Size</p>
                          </div>
                          <div>
                            <p *ngIf="listingDetails?.building_area" class="f-12 font-weight-bold">
                              {{ listingDetails.building_area }}
                              <span *ngIf="listingDetails.building_area_type == 'm2'; else elsePart">m<sup>2</sup></span>
                              <ng-template #elsePart>
                                {{ listingDetails.building_area_type }}
                              </ng-template>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="divShadow p-0">
                    <div class="row">
                      <div class="pricingDetail border-bottom-0 col-sm-6 p-3" id="lisitng-agent-primary">
                        <div class="d-flex align-items-center" *ngIf="listingDetails?.agent?.full_name">
                          <p class="agent-title f-18" title="{{ listingDetails?.agent?.full_name }}">
                            {{ listingDetails?.agent?.first_name?.charAt(0) + '' + listingDetails?.agent?.last_name?.charAt(0) }}
                          </p>
                          <div class="ml-2">
                            <p class="f-14 font-weight-bold">{{ listingDetails?.agent?.full_name }}</p>
                            <p class="f-12" *ngIf="listingDetails?.agent?.full_name">Agent</p>
                          </div>
                        </div>
                      </div>
                      <div class="pricingDetail border-bottom-0 col-sm-6 p-3" id="lisitng-agent-secondary">
                        <div class="d-flex align-items-center" *ngIf="listingDetails?.secondaryagent?.full_name">
                          <p class="agent-title f-18" title="{{ listingDetails?.secondaryagent?.full_name }}">
                            {{ listingDetails?.secondaryagent?.first_name?.charAt(0) + '' + listingDetails?.secondaryagent?.last_name?.charAt(0) }}
                          </p>
                          <div class="ml-2">
                            <p class="f-14 font-weight-bold">{{ listingDetails?.secondaryagent?.full_name }}</p>
                            <p class="f-12" *ngIf="listingDetails?.secondaryagent?.full_name">Agent</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="divShadow p-0">
                    <div class="priDetail pt-0" id="listing-inspection">
                      <p class="insp-heading f-18">Inspection</p>
                      <ng-container *ngIf="listingDetails?.appointments_and_inspections?.length > 0; else no_inspection">
                        <div *ngFor="let item of listingDetails?.appointments_and_inspections" class="mb-2">
                          <ng-container *ngIf="item?.isInspection == true">
                            <p class="font-style">{{ item.event.start.dateTime | wallClock | date: 'EEEE, d MMM y' }}</p>
                            <p class="time-style">
                              {{ getTimeFormat(item.event.start.dateTime) }} -
                              {{ getTimeFormat(item.event.end.dateTime) }}
                            </p>
                          </ng-container>
                        </div>
                      </ng-container>
                      <ng-template #no_inspection>
                        <p class="font-style">There are no upcoming inspections for this property</p>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="divShadow p-0">
                    <ng-container *ngIf="listingDetails?.listing_type === 'Auction'">
                      <div class="priDetail pt-0" id="listing-auction">
                        <p class="insp-heading f-18">Auction</p>
                        <p class="time-style">{{ getTimeFormat(listingDetails.startTime) }}</p>
                        <p class="font-style">{{ listingDetails?.date | date: 'EEEE, d MMM y' }}</p>
                      </div>
                    </ng-container>
                    <div class="priDetail border-bottom-0" id="lisitng-overview">
                      <p class="insp-heading f-18">Listing Overview</p>
                      <p class="font-style font-weight-bold mb-2">{{ listingDetails?.heading }}</p>
                      <p class="time-style" [innerHTML]="listingDetails?.description_garax"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-panel-page">
              <p class="insp-heading f-18">Comments</p>
              <app-approvel-comments
                [showPublicComments]="true"
                [readWritePermissions]="readWritePermissions"
                [comments]="listingComments"
                [vendorComments]="vendorComments"
                [lisitngDetail]="listingDetails"
                [cb_afterupdate]="onUpdatecallback.bind(this)"></app-approvel-comments>
            </div>
          </div>
          <div class="confirmation-dialog-footer mr-2 mb-3 ml-auto"></div>
        </div>
      </div>
    </div>
    <div class="office-footer-style" [ngStyle]="{ 'background-color': listingDetails?.offices?.background_color }">
      <ng-container *ngIf="listingDetails?.office_logos; else officeNameFooter">
        <div>
          <img src="{{ S3Path + listingDetails?.office_logos?.file }}" alt="" width="50" height="45" class="mr-2" />
        </div>
      </ng-container>
      <ng-template #officeNameFooter>
        <p class="f-24" [ngStyle]="{ color: listingDetails?.offices?.text_color }">{{ listingDetails?.offices?.name }}</p>
      </ng-template>
      <div>
        <p class="_fw-600 f-16" hoverHighlightInfo id="listing-greeting" [ngStyle]="{ color: listingDetails?.offices?.text_color }">
          {{ listingDetails?.agent?.full_name }}
        </p>
        <p class="_fw-500 f-14" hoverHighlightInfo id="listing-greeting" [ngStyle]="{ color: listingDetails?.offices?.text_color }">
          {{ listingDetails?.agent?.email }}
        </p>
        <p class="_fw-500 f-14" hoverHighlightInfo id="listing-greeting" [ngStyle]="{ color: listingDetails?.offices?.text_color }">
          {{ listingDetails?.agent?.mobile }}
        </p>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="pageLoad == false">
  <div class="office-header-style" [ngStyle]="{ 'background-color': listingDetails?.offices?.background_color }">
    <ng-container *ngIf="listingDetails?.office_logos; else officeName">
      <div>
        <img src="{{ S3Path + listingDetails?.office_logos?.file }}" alt="" width="50" height="45" class="mr-2" />
      </div>
    </ng-container>
    <ng-template #officeName>
      <p class="f-24" [ngStyle]="{ color: listingDetails?.offices?.text_color }">{{ listingDetails?.offices?.name }}</p>
    </ng-template>
  </div>
  <div class="link-expire-box">
    <div class="link-expire">
      <div class="mt-5">
        <i class="pi pi-exclamation-triangle f-85"></i>
      </div>
      <p class="f-18 _fw-600 mt-4">Oops! We are sorry, but the link is no longer available</p>
    </div>
  </div>
  <div class="office-footer-link" [ngStyle]="{ 'background-color': listingDetails?.offices?.background_color }">
    <ng-container *ngIf="listingDetails?.office_logos; else officeNameFooter">
      <div>
        <img src="{{ S3Path + listingDetails?.office_logos?.file }}" alt="" width="50" height="45" class="mr-2" />
      </div>
    </ng-container>
    <ng-template #officeNameFooter>
      <p class="f-24" [ngStyle]="{ color: listingDetails?.offices?.text_color }">{{ listingDetails?.offices?.name }}</p>
    </ng-template>
    <div>
      <p class="_fw-600 f-16" hoverHighlightInfo id="listing-greeting" [ngStyle]="{ color: listingDetails?.offices?.text_color }">
        {{ listingDetails?.agent?.full_name }}
      </p>
      <p class="_fw-500 f-14" hoverHighlightInfo id="listing-greeting" [ngStyle]="{ color: listingDetails?.offices?.text_color }">
        {{ listingDetails?.agent?.email }}
      </p>
      <p class="_fw-500 f-14" hoverHighlightInfo id="listing-greeting" [ngStyle]="{ color: listingDetails?.offices?.text_color }">
        {{ listingDetails?.agent?.mobile }}
      </p>
    </div>
  </div>
</ng-container>
